import PrButtonComponent from './pr-button';

export default PrButtonComponent;